import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle, Badge } from '@components';
import { Call } from '../hooks';

interface RecentCallsProps {
  calls: Call[];
}

export const RecentCalls: React.FC<RecentCallsProps> = ({ calls }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl font-semibold text-gray-900 dark:text-white">
          {t('dashboard.recentCalls')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-200 dark:border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {t('common.time')}
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {t('calls.caller')}
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {t('calls.agent')}
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {t('calls.duration')}
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
                  {t('common.status')}
                </th>
              </tr>
            </thead>
            <tbody>
              {calls.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-4 py-12">
                    <div className="text-center">
                      <span className="material-icons text-4xl text-gray-400 dark:text-gray-500">
                        phone
                      </span>
                      <p className="text-gray-600 dark:text-gray-400 mt-4 text-lg">
                        {t('dashboard.noDataAvailable')}
                      </p>
                      <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">
                        {t('dashboard.noRecentCalls')}
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                calls.map((call, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800/50"
                  >
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {call.time}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-900 dark:text-white font-medium">
                      {call.caller}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {call.agent}
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-600 dark:text-gray-400">
                      {call.duration}
                    </td>
                    <td className="py-3 px-4">
                      <Badge variant="success" size="sm">
                        {call.status}
                      </Badge>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
